import {Dispatch, SetStateAction} from 'react';

export enum AssaysStatuses {
  NotReady,
  InProgress,
  Done,
}


export enum AssaysStatusesColors {
  Done = '#00B3A1',
  InProgress = '#E7B416',
  NotReady = '#E42D24',
}

export interface IAssay {
  name: string,
  status: AssaysStatuses
}

export interface IOrder {
  id: number,
  date: string,
  address: string,
  assays: IAssay[]
}

export type Orders = IOrder[];


export interface IClient {
  firstName: string,
  secondName: string,
  middleName: string,
  birthday: string,
  age: number,
  gender: string,
  phoneNumber: string,
  accessKey: string,
}

export type UseClientState = [null | IClient, Dispatch<SetStateAction<IClient | null>>];
export type UseOrdersState = [null | Orders, Dispatch<SetStateAction<Orders | null>>]

export interface IAppState {
  client: UseClientState;
  orders: UseOrdersState;
}
